
import { VTabs } from "vuetify/lib";

export default VTabs.extend({});
